import React from 'react';

/**
 * ShopLoader Component
 *
 * This component serves as a spinning loader for the shop page. It can be used
 * anywhere in the application where a loading indicator is needed. The loader
 * is represented by a simple span element with a class of "loader", which can
 * be styled with CSS to create a spinning effect.
 *
 * Example Usage:
 * <ShopLoader />
 *
 * You can customize the loader's appearance by modifying the CSS associated
 * with the "loader" class.
 */
export const ShopLoader = () => {
  return (
    <>
      <span className="loader"></span>
    </>
  );
};

export const PriceLoader = () => {
  return <div className="skeleton skeleton-price"></div>;
};

export const PriceLoaderSmall = () => {
  return <div className="skeleton skeleton-price-small"></div>;
};


export const TitleLoader = () => {
  return <div className="skeleton skeleton-title"></div>;
};
export const TitleLoaderSmall = () => {
  return <div className="skeleton skeleton-title-small"></div>;
};

export const DescriptionLoader = () => {
  return (
    <>
      {/* Description Skeleton */}
      <div className="skeleton-text-block">
        <div className="skeleton skeleton-text skeleton-text-long"></div>
        <div className="skeleton skeleton-text skeleton-text-medium"></div>
        <div className="skeleton skeleton-text skeleton-text-short"></div>
      </div>
    </>
  );
};
